import { createPortal } from "react-dom";
import Div from "../Div";
import Form from "../Form";
import FormButton from "../FormButton";
import { useState, useCallback, useEffect } from "react";
import { segments, zones } from "../../util/enum";
import { getAssignedToData, updateRenewalDomainData } from "../../http/renewalHttp/RenewalHttp";
import Input from "../Input";
import Select from "../Select";


export default function UpdateRenewalDomainDetailModal({ customer_data, handleClicked, ...props }) {

    // const [selectedSegment, setSelectedSegment] = useState({});
    const [assignedToList, setAssignedToList] = useState([]);
    function handleClose() {
        handleClicked(false);
    }

    // const handleSegmentChange = (renewal_id, value) => {
    //     setSelectedSegment(prev => ({ ...prev, [renewal_id]: value }));
    // };

    const state = segments.segment.map((state) =>
        state.id !== customer_data ?
            <option key={state.id}
                name={state.id}
                value={state.id}>
                {state.value}</option>
            : null)

    const zone = zones.zone.map((zone) =>

        <option key={zone.id}
            name={zone.id}
            value={zone.id}>
            {zone.value}</option>);

    const fetchAssignedUsers = useCallback(async () => {
        const response = await getAssignedToData()
        if (response) {
            console.log(response)
            const assigned_to_response = response.domain.map((state) =>

                <option key={state.assigned_to}
                    name={state.assigned_to}
                    value={state.assigned_to}>
                    {state.assigned_to}</option>
            )
            setAssignedToList(assigned_to_response)
            // setInitialCustomerList(response.customer)
        }
    }, []);

    useEffect(() => {
        fetchAssignedUsers();
    }, [fetchAssignedUsers])


    //   const handleUpdateSegment = async (renewal_id) => {
    //         if (selectedSegment[renewal_id]) {
    //             const segmentResponse = await updateSegmentsHttp(renewal_id, selectedSegment[renewal_id])
    //             if (!segmentResponse) {
    //                 alert('Failed to Update Segment. Please try refreshing the page');
    //             } else {
    //                 alert('Segment Updated Successfully')
    //             }
    //         }
    //     };

    async function handleFormSubmit(event) {
        event.preventDefault();

        const registerFD = new FormData(event.target)

        const data = Object.fromEntries(registerFD.entries())

        if (data.customer_segment === ''){
            data.customer_segment = customer_data.segments 
        }

        if (data.customer_zone === ''){
            data.customer_zone = customer_data.zone 
        }

        if (data.user_status === ''){
            data.user_status = customer_data.assigned_to 
        }

        // console.log(data, customer_data.renewal_id)

        const response =await updateRenewalDomainData(data, customer_data.renewal_id)
        console.log(response)
        alert('Domain Details Updated Successfully')
        handleClicked(false)
        window.location.reload();
    }


    return (
        customer_data && createPortal(
            <Div className="modal-backdrop">
                <dialog {...props} style={{ zIndex: 1, maxWidth: "100%" }}>
                    <Div className="form-group">Update Domain Details</Div>
                    <Form onSubmit={handleFormSubmit}>
                        <Div className="form-group">
                            <Input value={customer_data.domain_name} name="domain_name" type="text" className="form-control" disabled />
                        </Div>

                        <Div className="form-group">
                            <label>Customer Segment</label>
                            <Select name='customer_segment' options={state} defaultValue={customer_data.segments}
                                // onChange={(e) => handleSegmentChange(customer_data.renewal_id, e.target.value)}
                                style={{ width: 'auto', marginLeft: '10px' }} />


                        </Div>

                        <Div className="form-group">
                            <label>Company Zone</label>
                            <Select name='customer_zone' options={zone} defaultValue={customer_data.zone}
                                // onChange={(e) => handleSegmentChange(customer_data.renewal_id, e.target.value)}
                                style={{ width: 'auto', marginLeft: '10px' }} />
                        </Div>

                        <Div className="form-group">
                            <label>Assigned To</label>
                            <Select name='user_status' options={assignedToList ? assignedToList : null}
                                defaultValue={customer_data.assigned_to}
                                // onChange={(e) => handleSegmentChange(customer_data.renewal_id, e.target.value)}
                                style={{ width: 'auto', marginLeft: '10px' }} />
                        </Div>

                        <Div className="form-group">
                            <Div className="row">
                                <Div className="col-sm-6">
                                    <FormButton type="submit" className="btn btn-primary submit-btn btn-block">Update Domain</FormButton>
                                </Div>
                                <Div className="col-sm-6">
                                    <FormButton type="button" onClick={handleClose} className="btn btn-primary submit-btn btn-block">Close</FormButton>
                                </Div>
                            </Div>
                        </Div>
                    </Form>
                </dialog>
            </Div>,
            document.getElementById("modal")
        )
    );
}
